// MOMKIS - Fiche produit : synchronisations légères par-dessus les
// composants Dawn natifs (aucune logique de variante/panier réimplémentée).
//
// Dawn (product-info.js) remplace ENTIÈREMENT le nœud <product-info> à
// chaque changement de variante (HTMLUpdateUtility.viewTransition insère un
// nouveau nœud puis supprime l'ancien ~500ms après). Un MutationObserver
// attaché à un élément précis à l'intérieur de <product-info> devient donc
// orphelin après le premier changement de variante. On observe à la place
// le PARENT stable (.momkis-pdp-scope, jamais remplacé) et on re-cherche le
// nouveau <product-info> à chaque mutation.
//
// Trois choses sont synchronisées ici, toutes dérivées de données déjà
// rendues par Dawn (jamais de prix/texte codé en dur) :
// 1. Pastilles de couleur : si l'option "Couleur"/"Color" n'a pas de swatch
//    Shopify natif, on la transforme visuellement via un mapping couleur
//    centralisé (fallback uniquement — le swatch natif reste prioritaire).
// 2. Prix dans le bouton "Ajouter au panier" (le snippet buy-buttons.liquid
//    natif n'inclut pas le prix dans son libellé) : on lit le prix déjà
//    affiché par snippets/price.liquid et on l'ajoute au libellé du bouton.
// 3. Mirroir de l'état du vrai bouton (disabled + libellé) vers la barre
//    sticky mobile et le CTA final, qui soumettent le même <form> natif.

(function () {
  // Mapping couleur centralisé dans assets/momkis-color-map.js (chargé sur
  // toutes les pages, y compris hors fiche produit, puisque le panier peut
  // aussi en avoir besoin pour ses cartes cross-sell). Repli défensif si ce
  // fichier n'était pas chargé pour une raison quelconque.
  window.MOMKIS_COLOR_MAP = window.MOMKIS_COLOR_MAP || {};

  function enhanceColorSwatches(root) {
    root.querySelectorAll('fieldset.product-form__input--pill').forEach(function (fieldset) {
      var legend = fieldset.querySelector('.form__label');
      var legendText = legend ? legend.textContent.trim().toLowerCase() : '';
      if (legendText.indexOf('couleur') !== 0 && legendText.indexOf('color') !== 0) return;

      fieldset.classList.add('momkis-swatch-fieldset');
      fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var label = input.nextElementSibling;
        if (!label || label.tagName !== 'LABEL') return;
        label.classList.add('momkis-swatch');
        var name = input.value.trim();
        label.setAttribute('aria-label', name);
        var color = window.MOMKIS_COLOR_MAP[name.toLowerCase()];
        if (color) label.style.backgroundColor = color;
      });
    });
  }

  function currentVariantPriceText(root) {
    var priceRegion = root.querySelector('[id^="price-"]');
    var priceEl = priceRegion ? priceRegion.querySelector('.price') : null;
    if (!priceEl) return null;
    var onSale = priceEl.classList.contains('price--on-sale');
    var item = onSale
      ? priceEl.querySelector('.price__sale .price-item--sale')
      : priceEl.querySelector('.price__regular .price-item--regular');
    return item ? item.textContent.trim() : null;
  }

  function updateSubmitLabel(root) {
    var btn = root.querySelector('[id^="ProductSubmitButton-"]');
    if (!btn) return;
    var span = btn.querySelector('span');
    if (!span) return;

    if (btn.disabled) {
      span.removeAttribute('data-momkis-base-label');
      return;
    }

    var base = span.getAttribute('data-momkis-base-label');
    if (!base) {
      base = span.textContent.replace(/\s*—.*$/, '').trim();
      span.setAttribute('data-momkis-base-label', base);
    }

    var priceText = currentVariantPriceText(root);
    var next = priceText ? base + ' — ' + priceText : base;
    if (span.textContent.trim() !== next) span.textContent = next;
  }

  function translateJudgemeBadge(root) {
    var badge = root.querySelector('.momkis-pdp-buybox__jdgm-badge');
    if (badge && window.momkisTranslateJudgeme) window.momkisTranslateJudgeme(badge);
  }

  function mirrorState(root) {
    var btn = root.querySelector('[id^="ProductSubmitButton-"]');
    var mirrors = document.querySelectorAll('[data-momkis-cta-mirror]');
    if (!btn || !mirrors.length) return;

    var span = btn.querySelector('span');
    var text = span ? span.textContent.trim() : btn.textContent.trim();
    var disabled = btn.disabled;

    mirrors.forEach(function (mirror) {
      mirror.disabled = disabled;
      var labelTarget = mirror.querySelector('[data-momkis-cta-label]');
      if (labelTarget && labelTarget.textContent.trim() !== text) labelTarget.textContent = text;
    });
  }

  function refresh(scope) {
    var productInfoId = scope.getAttribute('data-momkis-product-info-id');
    var root = productInfoId ? document.getElementById(productInfoId) : null;
    if (!root) return;

    enhanceColorSwatches(root);
    updateSubmitLabel(root);
    mirrorState(root);
    translateJudgemeBadge(root);
  }

  function init() {
    var scope = document.querySelector('.momkis-pdp-scope[data-momkis-product-info-id]');
    if (!scope) return;

    refresh(scope);

    new MutationObserver(function () {
      refresh(scope);
    }).observe(scope, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
